import { Alert, List, ListItem, Slide, Snackbar } from "@mui/material";
import { useSnackbars } from "../../store/snackbars/hooks";

export const ImportErrorSnackbar = () => {
  const {
    importErrorMessage,
    showImportErrorSnackbar,
    clearImportErrorMessage,
    closeImportErrorSnackbar,
  } = useSnackbars();

  const handleClose = () => closeImportErrorSnackbar();
  const handleExited = () => clearImportErrorMessage();

  return (
    <Snackbar
      open={showImportErrorSnackbar}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      autoHideDuration={5000}
      onClose={handleClose}
      slots={{
        transition: Slide,
      }}
      slotProps={{
        transition: {
          direction: "up",
          onExited: handleExited,
        },
      }}
    >
      <Alert
        onClose={handleClose}
        variant="filled"
        severity="warning"
        sx={{
          boxShadow: 3,
        }}
      >
        {importErrorMessage ? (
          <List disablePadding>
            {importErrorMessage?.map((error, index) => (
              <ListItem disablePadding key={index}>
                {error}
              </ListItem>
            ))}
          </List>
        ) : (
          "An error occurred during import. Please try again."
        )}
      </Alert>
    </Snackbar>
  );
};
